"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureFlagWithSubjectType = void 0;
function isFeatureFlagWithSubjectType(flag) {
    return typeof flag === 'object' && flag !== null && 'key' in flag;
}
exports.isFeatureFlagWithSubjectType = isFeatureFlagWithSubjectType;
